// extracted by mini-css-extract-plugin
export default {"withNoBorder":"TagsBadgesListPage_withNoBorder__SpVmO"};